{
  "version": 1,
  "asset_id": "00466c40-680f-4ad5-bd2c-c4578b7662d2",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/00466c40-680f-4ad5-bd2c-c4578b7662d2/revision-hub-annotated-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/00466c40-680f-4ad5-bd2c-c4578b7662d2/revision-hub-annotated-1200.jpg",
  "original_filename": "revision-hub-annotated-1200.jpg",
  "size": 127904,
  "content_type": "image/jpeg",
  "created_at": "2026-10-05T21:16:49Z"
}
